export const LOGON_PAGE = "/logon";
export const WELCOME_PAGE = "/welcome";
export const API_PAGE = "/api";
export const ACCOUNT_PAGE = "/account";
export const E_COMMERCE_PAGE = "/ecommerce";
